/**
 * Helpers to format a tool-execution error for the LLM and for the chat UI.
 */

import type { ToolErrorResponse } from './base.ts';

/**
 * Render a structured tool-error response into the markdown text shown in
 * the assistant-ui error part. The LLM also receives this string when its
 * tool call results in a failure.
 */
export function formatErrorText(response: ToolErrorResponse): string {
  const lines: string[] = [`**${humanizeErrorType(response.errorType)}**`, response.error];
  if (response.suggestions.length > 0) {
    lines.push('', ...response.suggestions.map((s) => `- ${s}`));
  }
  return lines.join('\n');
}

/**
 * Convert a `PascalCaseError` class name into a Title Case label suitable for
 * display: `ColumnNotFoundError` → `Column Not Found`.
 *
 * Strips the trailing `Error` suffix and inserts spaces between word
 * boundaries (camelCase / acronym handling).
 */
export function humanizeErrorType(errorType: string): string {
  const withoutSuffix = errorType.endsWith('Error') ? errorType.slice(0, -'Error'.length) : errorType;
  return withoutSuffix
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .trim();
}
